export default __webpack_public_path__ + "static/media/eye.1c4c54f9.svg";